import React, { Fragment } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { WithTooltip, tooltipTitleCss } from '../../design-system'
import { CsWarningIcon } from '../../legacy-design-system/icons'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { css } from '@emotion/css'
import { Placement } from '../../legacy-design-system/popper'
import { Link } from '@contrast-security-inc/design-system-typography'

export const licenceTooltipContentTestId = 'licence-tooltip-content'

export interface AgentStatusTooltipProps {
  readonly latestAgentVersion: string
  readonly outOfDate: boolean
  readonly placement?: Placement
  readonly size?: number
}

const listItemCss = css`
  text-indent: -3px;
`

export function AgentStatusTooltip({
  latestAgentVersion,
  outOfDate,
  placement,
  size
}: AgentStatusTooltipProps) {
  return (
    <Fragment>
      {outOfDate && (
        <WithTooltip
          placement={placement}
          renderTooltipContent={() => (
            <AgentStatusTooltipContent
              latestAgentVersion={latestAgentVersion}
              outOfDate={outOfDate}
            />
          )}
          children={() => (
            <CsWarningIcon size={size} color={theme.color.neutral60} />
          )}
        />
      )}
    </Fragment>
  )
}

export function AgentStatusTooltipContent({
  latestAgentVersion,
  outOfDate
}: AgentStatusTooltipProps) {
  const intl = useIntl()

  return (
    <div
      className={css`
        max-width: 250px;
      `}
    >
      <FormattedMessage
        id="title_warnings"
        children={(title) => <span className={tooltipTitleCss}>{title}</span>}
      />
      <ul
        className={css`
          padding-left: 15px;
          padding-top: 10px;
        `}
      >
        {outOfDate && (
          <li className={listItemCss}>
            <FormattedMessage
              id="detail_servers_agentOutOfDate"
              values={{
                latestVersionLink: (
                  <Link
                    href={intl.formatMessage({ id: 'link_release' })}
                    className={css`
                      color: ${theme.color.turquoise50} !important;
                    `}
                  >
                    {latestAgentVersion}
                  </Link>
                )
              }}
            />
          </li>
        )}
      </ul>
    </div>
  )
}
